import React,{useState,useEffect,useRef} from "react";
import { Link,useHistory} from "react-router-dom";
import {Modal} from 'react-bootstrap';
import Sidebar from './Sidebar';
import AdminNavbar from './AdminNavbar';
import { CardImage,BookmarkFill,TrashFill,EyeFill,Wallet } from 'react-bootstrap-icons';
import { useTable } from 'react-table'
import { timestampDate } from './../../helpers';
import { Path,setting_table_id,bucketName,dirName,region,accessKeyId,secretAccessKey } from './Path';
import { DataStore,Predicates } from '@aws-amplify/datastore';
import {WithdrawalRequest} from './../../models';
import { Amplify, API, graphqlOperation } from 'aws-amplify';
import awsconfig from './../../aws-exports1';
import ReactQuill from 'react-quill'; 
import 'react-quill/dist/quill.snow.css';
import './../../css/main.css';
Amplify.configure(awsconfig);
function WithdrawalRequests()  {
    let history = useHistory();
    const [allData, setAllData] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmId, setConfirmId] = useState(0);
    const [errors, setErrors] = useState('');
    const get_status = useRef(null);
    const [notification, setNotification] = useState({success:'',failed:'',show_success:false,show_failed:false});
    const [active_class, setActiveClass] = useState('faq');

    const [Opacity, setOpacity] = useState('1');
    const [PointerEvents, setPointerEvents] = useState('');
    const [Loader, setLoader] = useState(false);
    
    const viewConfirmModal=(val,modal_value)=>{
      setConfirmId(val);
      setShowConfirmModal(modal_value)
    }
    const search_data=async()=>{
      if(get_status.current.value!==''){
        await DataStore.query(WithdrawalRequest, c => c.status("eq", get_status.current.value)).then((data)=>{
          setAllData(data);
        }).catch((err)=>{
            console.log(err);
        })
      }else{
        await DataStore.query(WithdrawalRequest).then((data)=>{
          setAllData(data);
        }).catch((err)=>{
            console.log(err);
        })
      }
    }
    const get_data=async()=>{
       await DataStore.query(WithdrawalRequest).then((data)=>{
        setAllData(data);
        console.log(data);
      }).catch((err)=>{
          console.log(err);
      })
    }
    const hide_notification=()=>{
      setNotification({sucess:'',failed:'',show_failed:false,show_success:false});
      setErrors('');
    }
    const update_status=async()=>{
      const original = await DataStore.query(WithdrawalRequest,confirmId)
        await DataStore.save(
          WithdrawalRequest.copyOf(original, updated => {
            updated.status=`${'approved'}`;
          })
      ).then((data)=>{
          setLoader(false);
          setOpacity('');
          setPointerEvents('');
          setShowConfirmModal(false);
          get_data();
          setNotification({success:'Status updated successfully.',failed:'',show_failed:false,show_success:true});
          setErrors('');	
          setTimeout(hide_notification, 4000);
      }).catch((err)=>{
          setNotification({success:'',failed:err,show_failed:true,show_success:false});
          setTimeout(hide_notification, 4000);
          setErrors('');	
      })    
    }
    useEffect(() => {
        if(localStorage.getItem('token')!==null && localStorage.getItem('token')!==undefined && localStorage.getItem('token')!==''){
          get_data();
        }else{
          history.push('/admin/login');
        }
    }, []);	
    const data = allData!=='' && allData.map(function(value) {
      return {
        col1:<p style={{textAlign:"left"}}>{value.wallet_address}</p>,
        col2: <p style={{textAlign:"left"}}>{value.reward}</p>,
        col3: <p style={{textAlign:"left"}}>{timestampDate(value.createdAt)}</p>,
        col4: <p className="action_btns">{value.status==='pending' ? (<span className="edit_icon" title="Approve" onClick={()=>viewConfirmModal(value.id,true)}><BookmarkFill size={16} color="#ffffff" /></span>) : (<span className="status_td">Approved</span>)}</p>
      }
    })
    // const data = React.useMemo(
    //     () => [
    //       {
    //         col1: '1regtfy546554654gfhgfhfghfghgfhgfhgfhf',
    //         col2: '20',
    //         col3: '14 March 2022 12:13:14',
    //         col4: <p className="action_btns"><span className="edit_icon" title="Approve"><BookmarkFill size={16} color="#ffffff" /></span></p>
    //       },
    //       {
    //         col1: '345534dgdfgdfg5464gdfgfdgfdh54654gdfghd',
    //         col2: '45',
    //         col3: '15 March 2022 12:13:14',
    //         col4: <p className="action_btns"><span className="edit_icon" title="Approve"><BookmarkFill size={16} color="#ffffff" /></span></p>
    //       },
    //       {
    //         col1: '54gdfhtgh546465465dgfhgdfhgfhgfh546dfgbd',
    //         col2: '10',
    //         col3: '15 March 2022 12:13:14',
    //         col4: <p className="action_btns"><span className="edit_icon" title="Approve"><BookmarkFill size={16} color="#ffffff" /></span></p>
    //       },
    //       {
    //         col1: '3grgtertredfgdgdfhghhghjdf5454545ghgfh54',
    //         col2: '30',
    //         col3: '11 March 2022 12:13:14',
    //         col4: <p className="action_btns"><span className="edit_icon" title="Approve"><BookmarkFill size={16} color="#ffffff" /></span></p>
    //       },
    //       {
    //         col1: '32gbfhgfy657hgfhfgy565yhfghfgh567yhfghgf',
    //         col2: '50',
    //         col3: '08 March 2022 12:13:14',
    //         col4: <p className="action_btns"><span className="edit_icon" title="Approve"><BookmarkFill size={16} color="#ffffff" /></span></p>
    //       },
    //     ],
    //     []
    //   )
   const columns = React.useMemo(
     () => [
       {
         Header: 'Wallet address',
         accessor: 'col1',
       },
       {
         Header: 'Reward',
         accessor: 'col2',
       },
       {
         Header: 'Date/Time',
         accessor: 'col3',
       },
       {
        Header: 'Action',
        accessor: 'col4',
      },
     ],
     []
   )
   const {
     getTableProps,
     getTableBodyProps,
     headerGroups,
     rows,
     prepareRow,
   } = useTable({ columns, data })
    return (
        <>
           <AdminNavbar/>
            <div className="row main_row" style={{width:"100%",margin:"0",height:"100vh"}}>
                <div className="col-xl-2 col-lg-3 col-md-3 sidebar_divv">
                    <Sidebar/>
                </div>
                <div className="col-xl-10 col-lg-9 col-md-9" style={{paddingLeft:"0",paddingRight:"0"}}>
                    <div className="page_head">
                        <div className="row main_row" style={{width:"100%",margin:"0"}}>
                            <div className="col-xl-6">
                                <h3 className="admin_faq_heading"><span><Wallet size={24} color="#4B4B4B" /></span> Withdrawal Requests</h3>
                            </div>
                        </div>
                    </div>
                    {notification.show_success ? (<div className="alert alert-success" id="success2">{notification.success}
                        <button type="button" className="close" data-dismiss="alert"></button>
                    </div>) : ('')}		
                    {notification.show_failed ? (<div className="alert alert-danger" id="danger2">{notification.failed}
                        <button type="button" className="close" data-dismiss="alert"></button>
                    </div>) : ('')}
                    {errors ?(<div className="alert alert-danger" style={{color: "#721c24"}}>{errors}</div>):('')}
                    <div className="admin_table_outer_div">
                      <div className="admin_tables">
                          <select className="form-control admin_selectbox" ref={get_status} onChange={search_data}>
                            <option value="">All</option>
                            <option value="pending">Pending requests</option>
                          </select>
                          <table {...getTableProps()} className='users_tabl'>
                              <thead>
                              {headerGroups.map(headerGroup => (
                                  <tr {...headerGroup.getHeaderGroupProps()}>
                                  {headerGroup.headers.map(column => (
                                      <th
                                      {...column.getHeaderProps()}
                                      >
                                      {column.render('Header')}
                                      </th>
                                  ))}
                                  </tr>
                              ))}
                              </thead>
                              <tbody {...getTableBodyProps()}>
                              {rows.map(row => {
                                  prepareRow(row)
                                  return (
                                  <tr {...row.getRowProps()}>
                                      {row.cells.map(cell => {
                                      return (
                                          <td
                                          {...cell.getCellProps()}
                                          >
                                          {cell.render('Cell')}
                                          </td>
                                      )
                                      })}
                                  </tr>
                                  )
                              })}

                              {allData.length ===0 &&
                                (<tr style={{textAlign:"center"}}><td colSpan="4" className="no_records">No records found</td></tr>)
                              }
                              </tbody>
                          </table>
                      </div>
                    </div>
                </div>
            </div>
            {/* delete modal */}
            <Modal show={showConfirmModal} className="delete_modal">
              <Modal.Header style={{background:'none'}} closeButton onClick={() =>viewConfirmModal('',false)}>Change status</Modal.Header>
              <Modal.Body style={{textAlign:"center"}}>
                  <h4>Are you sure</h4>
                  <p>You want to change the status ?</p>
              </Modal.Body>
              <Modal.Footer>
                <div>
                  <button onClick={() =>viewConfirmModal('',false)} className="del_no_btn">No</button>
                  <button className="btn btn-primary del_yes_btn" style={{width:'auto',background:"#1890ff"}} onClick={update_status}>Yes</button>
                </div>
              </Modal.Footer><br/>
            </Modal>
        </>
    );
}
export default WithdrawalRequests;
